<script lang="ts">
  import { CostsFilter } from '../lib/costs-filter';

  interface Props {
    filter: CostsFilter;
    shown: number;
    total: number;
    onChange: (patch: Record<string, string | null>) => void;
  }

  let { filter, shown, total, onChange }: Props = $props();

  const hidden = $derived(total - shown);
</script>

<div class="filters">
  <label class="search">
    <span class="sr-only">Buscar na tabela</span>
    <span class="search-icon" aria-hidden="true">⌕</span>
    <input
      type="search"
      placeholder="Buscar cliente, workflow ou modelo"
      value={filter.search}
      oninput={(e) => onChange({ busca: (e.currentTarget as HTMLInputElement).value || null })}
    />
  </label>

  <div class="chips" role="group" aria-label="Origem do gasto">
    {#each CostsFilter.originOptions() as option (option.slug)}
      <button
        class="chip"
        aria-pressed={filter.origin === option.slug}
        class:on={filter.origin === option.slug}
        onclick={() => onChange({ origem: filter.origin === option.slug ? null : option.slug })}
      >
        {option.label}
      </button>
    {/each}
    <button
      class="chip"
      aria-pressed={filter.withTests}
      class:on={filter.withTests}
      onclick={() => onChange(filter.withTestsPatch)}
    >
      Com os meus testes
    </button>
    <button
      class="chip"
      aria-pressed={filter.onlyUnpriced}
      class:on={filter.onlyUnpriced}
      onclick={() => onChange({ 'sem-preco': filter.onlyUnpriced ? null : '1' })}
    >
      Sem preço
    </button>
  </div>

  <div class="tail">
    {#if !filter.isEmpty}
      <span class="count mono">{shown} de {total}{hidden > 0 ? ` · ${hidden} fora` : ''}</span>
      <button class="clear" onclick={() => onChange(CostsFilter.cleared())}>Limpar</button>
    {/if}
  </div>
</div>

<style>
  .filters {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: var(--space-3);
  }
  .search {
    position: relative;
    display: flex;
    align-items: center;
    flex: 1 1 260px;
    max-width: 360px;
  }
  .search-icon {
    position: absolute;
    left: var(--space-3);
    color: var(--text-tertiary);
    font-size: 14px;
    pointer-events: none;
  }
  .search input {
    width: 100%;
    padding: var(--space-2) var(--space-3) var(--space-2) var(--space-6);
    font-size: 13px;
    color: var(--text-primary);
    background: var(--bg-elevated);
    border: 1px solid var(--border-subtle);
    border-radius: var(--radius-md);
  }
  .search input::placeholder {
    color: var(--text-tertiary);
  }
  .search input:focus-visible {
    outline: 2px solid var(--color-success);
    outline-offset: -1px;
  }
  .chips {
    display: flex;
    gap: var(--space-2);
  }
  .chip {
    padding: var(--space-1) var(--space-3);
    font-size: 12px;
    color: var(--text-tertiary);
    background: var(--bg-elevated);
    border: 1px solid var(--border-subtle);
    border-radius: 999px;
    cursor: pointer;
    transition: color var(--duration-fast) var(--easing-default);
  }
  .chip:hover {
    color: var(--text-secondary);
  }
  .chip:focus-visible {
    outline: 2px solid var(--color-success);
    outline-offset: 1px;
  }
  .chip.on {
    color: var(--text-primary);
    border-color: var(--color-success);
  }
  .tail {
    display: flex;
    align-items: center;
    gap: var(--space-2);
    margin-left: auto;
  }
  .count {
    font-size: 11px;
    color: var(--text-tertiary);
  }
  .clear {
    font-size: 12px;
    color: var(--text-secondary);
    background: none;
    border: none;
    cursor: pointer;
    text-decoration: underline;
  }
  .clear:focus-visible {
    outline: 2px solid var(--color-success);
    outline-offset: 2px;
  }
  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    clip: rect(0 0 0 0);
    white-space: nowrap;
  }
</style>
